import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=76961daa&scoped=true"
import script from "./CharacterForm.vue?vue&type=script&lang=js"
export * from "./CharacterForm.vue?vue&type=script&lang=js"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=76961daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76961daa",
  null
  
)

export default component.exports